import { Education, Experience, Project, SocialLink } from '@/types';
import { FaGithub, FaLinkedin, FaTelegram, FaDiscord, FaEnvelope, FaStackOverflow } from 'react-icons/fa';

export const PERSONAL_INFO = {
  name: 'Danish Ismail',
  title: 'Senior Full-stack Blockchain Developer',
  email: 'dashdaniel717@gmail.com',
  phone: '+92 344 5163312',
  location: 'House 256D F10/1 Islamabad, Pakistan',
  about: "I'm a Full-stack Blockchain Developer with experience in multiple Blockchains like Ethereum, Polygon, Binance Smart-Chain, Avalanche, Fantom, Celo and Flow. I am also a contributor in Flow Blockchain with my other GitHub account. I am a problem solver who always thinks about how to solve real-life problems using high-end technology. I am committed to making society free from problems by making every possible business with inherent features – Transparency, Incentivization & Decision-making rights."
};

export const SOCIAL_LINKS: SocialLink[] = [
  {
    platform: 'GitHub',
    url: 'https://github.com/DanishIsmail',
    icon: FaGithub
  },
  {
    platform: 'LinkedIn',
    url: 'https://www.linkedin.com/in/danish-gakher-769b85189/',
    icon: FaLinkedin
  },
  {
    platform: 'Telegram',
    url: 'https://t.me/@DanishGakher',
    icon: FaTelegram
  },
  {
    platform: 'Discord',
    url: 'https://discordapp.com/users/Dash-Daniel#5538',
    icon: FaDiscord
  },
  {
    platform: 'Stack Overflow',
    url: 'https://stackoverflow.com/users/11208852/danish-gakher',
    icon: FaStackOverflow
  },
  {
    platform: 'Email',
    url: 'mailto:dashdaniel717@gmail.com',
    icon: FaEnvelope
  }
];

export const EDUCATION: Education[] = [
  {
    degree: 'BSCS, Computer Science',
    institution: 'University Of Poonch, Rawalakot AJ&K Pakistan',
    year: '2018 - 2022',
    description: 'Comprehensive study of computer science fundamentals, software development, and modern technologies'
  }
];

export const EXPERIENCE: Experience[] = [
  {
    position: 'Senior Full Stack Blockchain Developer',
    company: 'Troon Technologies',
    duration: 'Jan 2021 - Present',
    description: 'Leading blockchain projects including GRT-Health, Alvara Protocol, crypto-policy, real-Estate-App, strong-block, and more. Contributing to Flow Blockchain (onflow/Cadence) and ERC Standards development. Created Telegram Bots and Mini-Apps. Developing AI and data science projects like d-risk.',
    technologies: ['Flow', 'Ethereum', 'Polygon', 'BSC', 'Solidity', 'Cadence', 'Python', 'Go', '.Net Core', 'React', 'Node.js']
  },
  {
    position: 'Senior Full Stack Blockchain Developer',
    company: 'Renesis Tech',
    duration: 'Feb 2023 - Mar 2024',
    description: 'Leading development of One of a Mint (NFT platform with gasless transactions), ScarSpeed (XRP-based 3D racing game), WayGate NFT Marketplace (3D NFT platform), and HUTFIN Metaverse (multi-chain platform with CRENFTs). Also developed Bit-Blue, Atlanten, and Neo-Garden.',
    technologies: ['XRP Ledger', 'Smart Contracts', 'Web3.js', 'React', 'Node.js', 'Multi-chain', 'NFTs', 'DeFi']
  },
  {
    position: 'Full Stack Developer',
    company: 'Innovativity',
    duration: 'Aug 2021 - Oct 2021',
    description: 'Led B2C web application development using ASP.NET Core, created frontend applications with Angular.js, developed RESTful APIs, and mentored junior developers.',
    technologies: ['ASP.NET Core', 'Angular.js', 'REST APIs', 'SQL Server']
  },
  {
    position: 'Web Developer',
    company: 'DevSpot',
    duration: 'Jan 2020 - Jul 2020',
    description: 'Developed WordPress themes, created dynamic PHP solutions for projects like burka-avenger, KSU, and my-remedy-app. Worked on email templates for MailChimp.',
    technologies: ['PHP', 'WordPress', 'HTML', 'CSS', 'JavaScript']
  },
  {
    position: 'Quality Assurance Intern',
    company: 'Afiniti',
    duration: 'Jul 2020 - Sep 2020',
    description: 'Performed black box testing of Mega-Awaya-Agents product.',
    technologies: ['Testing', 'Quality Assurance']
  },
  {
    position: 'PHP Developer Intern',
    company: 'Troon Technologies',
    duration: 'Jan 2019 - Mar 2019',
    description: 'Worked on HRM system development and PSD to HTML conversion. Created interactive web applications.',
    technologies: ['PHP', 'HTML', 'CSS', 'JavaScript', 'MySQL']
  }
];

export const PROJECTS: Project[] = [
  {
    title: 'Alvara Protocol',
    description: 'Blockchain protocol implementation with advanced smart contract features and security measures. Part of Troon Technologies portfolio.',
    technologies: ['Smart Contracts', 'Solidity', 'Web3.js', 'React', 'Node.js'],
    liveUrl: 'https://alvara.xyz/'
  },
  {
    title: 'Telegram Mini Apps & Bots',
    description: 'Collection of Telegram Mini Apps for various blockchain functionalities including crypto trading and NFT interactions. Features bot integration and automated workflows.',
    technologies: ['Telegram API', 'Node.js', 'React', 'Web3.js'],
    liveUrl: ''
  },
  {
    title: 'One of a Mint',
    description: 'NFT platform with gasless transactions, web3 integrations, and Stripe payment gateway integration. Features include lazy minting, multi-chain support, subscriptions, and advanced NFT management.',
    technologies: ['Smart Contracts', 'Web3.js', 'React', 'Node.js', 'Stripe', 'IPFS'],
    // liveUrl: 'https://oneofamint.io'
    liveUrl: ''
  },
  {
    title: 'ScarSpeed',
    description: 'XRP-based 3D racing game marketplace featuring lazy minting, multi-signature functionality, XRP mobile wallet integration, and XRP SDK libraries. Built with advanced gameplay mechanics.',
    technologies: ['XRP Ledger', 'XRP SDK', 'React', 'Node.js', '3D Graphics', 'WebGL'],
    // liveUrl: 'https://scarspeed.io'
    liveUrl: ''
  },
  {
    title: 'WayGate NFT Marketplace',
    description: '3D NFT Marketplace with multi-chain integration, WayGate Token integration, and real-time blockchain data fetching. Features blockchain event listeners and automated data extraction.',
    technologies: ['Smart Contracts', 'Multi-chain', 'React', 'Node.js', 'Web3.js', 'Three.js'],
    // liveUrl: 'https://waygate.io'
    liveUrl: ''
  },
  {
    title: 'HUTFIN Metaverse',
    description: 'Multi-chain metaverse platform with CRENFTs including rental, swapping, breeding, and trading features. Supports multiple wallets and blockchain networks.',
    technologies: ['Smart Contracts', 'Multi-chain', 'React', 'Node.js', 'NFTs', 'WebGL'],
    liveUrl: 'https://hutfin.io'
  },
  {
    title: 'Bit-Blue',
    description: 'Whistleable solution with multi-chain integration and advanced NFT features including rental, swapping, breeding, and trading functionalities.',
    technologies: ['Smart Contracts', 'Multi-chain', 'React', 'Node.js', 'NFTs']
  },
  {
    title: 'Atlanten',
    description: 'Dynamic smart contract deployment platform with advanced API integration and automated contract management.',
    technologies: ['Smart Contracts', 'React', 'Node.js', 'Web3.js'],
    liveUrl: 'https://atlanten.io'
  },
  {
    title: 'Neo-Garden',
    description: 'Blockchain platform with USDT implementation, lazy minting, and advanced NFT functionality. Features web3 integrations and smart contract automation.',
    technologies: ['Smart Contracts', 'USDT', 'React', 'Node.js', 'Web3'],
    liveUrl: 'https://www.neogarden.io/'
  },
  {
    title: 'Flow Blockchain Contributions',
    description: 'Active contributor to Flow blockchain development with my other GitHub account (danishtroon). Contributed to onflow/cadence repository, implementing various NFT standards and marketplace functionalities.',
    technologies: ['Flow', 'Cadence', 'Smart Contracts', 'Go'],
    github: 'https://github.com/onflow/cadence/graphs/contributors'
  },
  {
    title: 'D-Risk AI Platform',
    description: 'AI and data science platform for risk assessment and management. Features machine learning models and predictive analytics.',
    technologies: ['Python', 'AI/ML', 'React', 'Node.js', 'Data Science'],
    liveUrl: 'https://d-risk.ai'
  },
  {
    title: 'Burka Avenger',
    description: 'Dynamic web platform for the award-winning animated series. Features content management and interactive elements.',
    technologies: ['PHP', 'WordPress', 'HTML', 'CSS', 'JavaScript'],
    liveUrl: 'https://app.burkaavenger.com/'
  }
];

export const GITHUB_PROFILE = 'https://github.com/DanishIsmail';

export const SKILLS = {
  blockchain: ['Ethereum', 'Polygon', 'BSC', 'Avalanche', 'Fantom', 'Celo', 'Flow', 'XRP Ledger'],
  languages: ['Solidity', 'Cadence', 'PHP', 'Python', 'Javascript', 'Typescript', 'C++', 'C#', 'HTML', 'CSS', 'GoLang', 'Rust'],
  frontend: ['HTML5', 'CSS3', 'Bootstrap', 'jQuery', 'React.js', 'Next.js', 'Nest.js', 'Angular.js'],
  backend: ['ASP.NET Core', 'Node.js', 'Express.js', 'WordPress', 'Laravel'],
  databases: ['SQL Server', 'MongoDB', 'PostgreSQL', 'MySQL', 'NoSQL'],
  tools: ['Web3.js', 'Ethers.js', 'FCL.js', 'Git', 'GitLab', 'Vercel', 'Heroku', 'RailwayApp'],
  other: ['Smart Contracts', 'NFTs', 'DeFi', 'Multi-chain Integration', 'Digital Wallets', 'ERC Standards', 'Telegram Bots']
};
